// Builds schema.org JSON-LD for the public price list so Google can read each service + price (NOK, incl. VAT).
const SITE = "https://rbtun.no";

const nums = (s) => (String(s).match(/\d[\d\s\u00a0]*/g) || []).map((n) => Number(n.replace(/[\s\u00a0]/g, ""))).filter((n) => n > 0);

const priceSpec = (raw) => {
  const n = nums(raw);
  if (!n.length) return null;
  const from = /^\s*(fra|from)\b/i.test(raw);
  const base = { "@type": "PriceSpecification", priceCurrency: "NOK", valueAddedTaxIncluded: true };
  if (n.length >= 2) return { ...base, minPrice: Math.min(...n), maxPrice: Math.max(...n) };
  return from ? { ...base, minPrice: n[0] } : { ...base, price: n[0] };
};

export const offer = (it) => {
  const spec = priceSpec(it.price);
  if (!spec) return null;
  const o = { "@type": "Offer", url: `${SITE}/priser`, priceCurrency: "NOK", priceSpecification: spec,
    itemOffered: { "@type": "Service", name: it.name_no, provider: { "@id": `${SITE}/#business` }, areaServed: "Stavanger" } };
  if (spec.price) o.price = spec.price;
  return o;
};

export const buildPriceSchema = (data) => {
  const cats = Array.isArray(data?.categories) ? data.categories : [];
  return {
    "@context": "https://schema.org",
    "@type": "AutoRepair",
    "@id": `${SITE}/#business`,
    name: "RB TUN AS",
    url: `${SITE}/`,
    hasOfferCatalog: {
      "@type": "OfferCatalog",
      name: "Prisliste",
      url: `${SITE}/priser`,
      itemListElement: cats.map((c) => ({
        "@type": "OfferCatalog",
        name: c.title_no,
        itemListElement: (c.items ?? []).map(offer).filter(Boolean),
      })),
    },
  };
};
